define('plugin/promotion/view/PromotionCodeInputView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Promotion code input view
     *
     * @class PromotionCodeInputView
     */
    return Marionette.ItemView.extend({

        template: '#promotion_code_input_view',
        ui: {
            btn: '#sb_promotion_apply_btn',
            input: '#sb_promotion_code_input'
        },
        events: {
            'click @ui.btn': 'applyPromoCode'
        },
        modelEvents: {
            'error:promotion': 'render'
        },

        applyPromoCode: function () {
            this.triggerMethod('apply:promo:code', this.model, this.ui.input.val());
        },

        serializeData: function () {
            return _.extend(Marionette.ItemView.prototype.serializeData.apply(this), {
                promotion_error: this.model.getPromotionError()
            });
        }

    });

});
